import FundOverview from "@/FundExplorer/components/Display/FundOverview";
import type { FundExplorerPanelConfig } from "@/FundExplorer/types";
import type { Tab } from "@/components/Tabs/types";
import type { ReactNode } from "react";

export default function getFundPanelTabContent(
	tab: Tab<keyof FundExplorerPanelConfig>,
	panelConfig: FundExplorerPanelConfig,
	fundId: number,
): ReactNode {
	const tabConfig = panelConfig[tab.key];
	if (!("config" in tabConfig)) {
		return <div>Tab config not found</div>;
	}
	switch (tab.key) {
		case "profile":
			return <div>Profile</div>;
		case "overview":
			return <FundOverview config={tabConfig.config} fundId={fundId} />;
		case "shareclassesPrices":
			return <div>Shareclasses Prices</div>;
		case "performance":
			return <div>Performance</div>;
		case "documents":
			return <div>Documents</div>;
	}
}
